import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  Select,
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

interface Props {
  open: boolean;
  handleStartRecording: (
    recordDurationValue: number,
    recordDurationUnit: string
  ) => void;
  handleClose: () => void;
}

type FormData = {
  value: number;
  unit: string;
};

const RecordDurationDialog = ({
  open,
  handleStartRecording,
  handleClose,
}: Props) => {
  const { handleSubmit, control, reset } = useForm<FormData>({
    defaultValues: {
      value: 5,
      unit: 'minutes',
    },
  });

  const onRecordingClicked = (data: FormData) => {
    handleStartRecording(data.value, data.unit);
    handleClose();
    reset();
  };

  return (
    <Dialog maxWidth='xs' open={open} onClose={handleClose}>
      <DialogTitle>Live Record Duration</DialogTitle>
      <form onSubmit={handleSubmit(onRecordingClicked)}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DialogContentText>
                Enter how long you would like to record for in live mode.
              </DialogContentText>
            </Grid>
            <Grid item xs={8}>
              <Controller
                name='value'
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    autoFocus
                    type='number'
                    name='value'
                    value={value}
                    fullWidth
                    onChange={onChange}
                  />
                )}
              />
            </Grid>
            <Grid item xs>
              <Controller
                control={control}
                name={'unit'}
                render={({ field: { onChange, value } }) => (
                  <Select fullWidth onChange={onChange} value={value}>
                    <MenuItem key={'seconds'} value={'seconds'}>
                      Seconds
                    </MenuItem>
                    <MenuItem key={'minutes'} value={'minutes'}>
                      Minutes
                    </MenuItem>
                    <MenuItem key={'hours'} value={'hours'}>
                      Hours
                    </MenuItem>
                  </Select>
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button variant='outlined' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant='outlined'
            type='submit'
            startIcon={<FiberManualRecordIcon style={{ fill: 'red' }} />}
          >
            Start Recording
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default RecordDurationDialog;
